import React from "react";
import styled from "styled-components/native";
import { useTheme } from "styled-components/native";

type NavigationBulletProps = {
  selected?: boolean;
  bulletWidth?: string;
  borderRadius?: string;
  changeSelectedIndex: any;
};

type CustomNavigationBulletProps = {
  bulletWidth?: string;
  backgroundColor?: string;
  borderRadius?: string;
};

const NavigationBullet = ({
  selected,
  bulletWidth,
  borderRadius,
  changeSelectedIndex,
}: NavigationBulletProps) => {
  const theme = useTheme();
  const backgroundColor = selected ? theme["extra-01"] : theme["extra-03"];
  bulletWidth = bulletWidth ?? "8px";
  borderRadius = borderRadius ?? "10px";

  return (
    <CustomNavigationBullet
      bulletWidth={bulletWidth}
      backgroundColor={backgroundColor}
      borderRadius={borderRadius}
      onPress={changeSelectedIndex}
    />
  );
};

const CustomNavigationBullet = styled.TouchableOpacity<CustomNavigationBulletProps>`
  height: ${({ bulletWidth }: { bulletWidth: string }) => bulletWidth};
  width: ${({ bulletWidth }: { bulletWidth: string }) => bulletWidth};
  border-radius: ${({ borderRadius }: { borderRadius: string }) =>
    borderRadius};
  background-color: ${({ backgroundColor }: { backgroundColor: string }) =>
    backgroundColor};
  margin: 0 10px;
`;

export default NavigationBullet;
